var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.category.ParentCategoryID)?_c('div',{staticClass:"categories"},[_c('router-link',{class:{
      'text-primary': _vm.currentCategory == _vm.category.CategoryID
    },attrs:{"to":`/${_vm.$i18n.locale}/shop/${_vm.category.CategoryID}`}},[_vm._v(_vm._s(_vm.category.Description)+" ")]),_vm._l((_vm.subcategories),function(subcategory){return _c('ul',{key:subcategory.CategoryID,staticClass:"subcategories"},[_c('li',[_c('router-link',{class:{
          'text-primary': _vm.currentCategory == subcategory.CategoryID
        },attrs:{"to":`/${_vm.$i18n.locale}/shop/${subcategory.CategoryID}`}},[_vm._v(_vm._s(subcategory.Description)+" ")])],1)])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }